import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as RunningSvg } from './assets/running.svg';

const RunningIcon = React.forwardRef((args, ref) => <SvgIcon component={RunningSvg} ref={ref} {...args} />);

export default RunningIcon;
